import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=66ff1dc0&scoped=true&"
import script from "./Resources.vue?vue&type=script&lang=ts&"
export * from "./Resources.vue?vue&type=script&lang=ts&"
import style0 from "./Resources.vue?vue&type=style&index=0&id=66ff1dc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ff1dc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ff1dc0')) {
      api.createRecord('66ff1dc0', component.options)
    } else {
      api.reload('66ff1dc0', component.options)
    }
    module.hot.accept("./Resources.vue?vue&type=template&id=66ff1dc0&scoped=true&", function () {
      api.rerender('66ff1dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/Resources.vue"
export default component.exports